import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'

import { Link } from '~/components'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import SVGImage from '~/components/Image/SVGImage'
import BackButton from '~/math-vault/components/Buttons/BackButton'
import ROUTES from '~/shared/constants/routes.const'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '40vw' }]

export default function HeaderNavbar({ title, route }: { title: string; route: string }): React.ReactElement {
  const { t } = useTranslation('imageAlt')

  const isMobile = useCheckBreakpoint({ lt: Breakpoint.SM })

  return (
    <div className="sticky top-0 w-full p-4 py-1 sm:py-4 z-75 flex items-center justify-between sm:justify-center border-b border-gray-light bg-white sm:opacity-75 drop-shadow-xl">
      <div className="sm:fixed sm:left-5 sm:top-1.5 z-modal">
        <BackButton href={route} />
      </div>

      {!isMobile && (
        <Link to={ROUTES.DASHBOARD}>
          <SVGImage
            alt={t('icons.houseOfMath')}
            height={45}
            loading="eager"
            srcKey="logos/house-of-math.svg"
            width={234}
          />
        </Link>
      )}

      {isMobile && (
        <Fragment>
          <h1 className="text-md text-transparent font-bold text-center bg-clip-text bg-gradient-to-r from-purple to-blue-icy">
            {title}
          </h1>
          <div className="z-modal">
            <Link to={ROUTES.DASHBOARD}>
              <ResponsiveImage
                alt={t('icons.homShortLogo3D')}
                height={36}
                imageClassName="w-9"
                loading="eager"
                mediaQuery={mediaQuery}
                srcKey="Math Vault/icons/hom-short-logo-3d.png"
                width={36}
              />
            </Link>
          </div>
        </Fragment>
      )}
    </div>
  )
}
